import { baseApi } from '@/services'
import { PaginatedResults, Tradeline } from '@/types/unlock'

export const tradelinesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTradelinesByApplication: builder.query<PaginatedResults<Tradeline[]>, string>({
      query: (applicationUUID) =>
        `v2/applications/${applicationUUID}/tradelines/?page_size=1000&account_status_type=Open`,
      providesTags: ['Tradeline'],
    }),
    getTradelinesModalByApplication: builder.query<PaginatedResults<Tradeline[]>, string>({
      query: (applicationUUID) =>
        `v2/applications/${applicationUUID}/tradelines-modal/?page_size=1000`,
      providesTags: ['Tradeline'],
    }),
    getLiens: builder.query<PaginatedResults<Tradeline[]>, string>({
      query: (applicationUUID) => `v2/applications/${applicationUUID}/liens/`,
      providesTags: ['Liens', 'Tradeline'],
    }),
    getPayoffs: builder.query<PaginatedResults<Tradeline[]>, string>({
      query: (applicationUUID) => `v2/applications/${applicationUUID}/payoffs/`,
      providesTags: ['Payoffs'],
    }),
    dtiQualifier: builder.mutation<{ metadata?: any; action: string }, { applicationId: string }>({
      query: ({ applicationId }) => ({
        url: `v2/applications/${applicationId}/tradelines-modal/dti-qualifier/`,
        method: 'POST',
      }),
      invalidatesTags: ['Application', 'Tradeline', 'ApplicationCalcs'],
    }),
  }),
})

export const {
  useGetTradelinesModalByApplicationQuery,
  useGetTradelinesByApplicationQuery,
  useLazyGetTradelinesByApplicationQuery,
  useLazyGetTradelinesModalByApplicationQuery,
  useGetLiensQuery,
  useGetPayoffsQuery,
  useDtiQualifierMutation,
} = tradelinesApi
